import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { FileUpload } from './FileUploadExtension';

export const FileUploadExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'FileUpload',
    component: FileUpload,
  }),
);
